module.exports = __webpack_public_path__ + "img/box.7384e247.png";